module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre14",
    attrs: {
      "id": "PART_I_CHAPTER_VI"
    }
  }, [_vm._v("CHAPTER VI."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("POLAR EQUIPMENTS.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("1. Every Arctic expedition should be guided by the experience\nof its predecessors, both in its plan and its equipment; and\nhence we have often to deplore the negligence of almost all\nPolar navigators in failing to inform those who follow them of\nwhat they actually saw, of their modes of procedure, or of\nthe mistakes which they committed. It will not, therefore,\nbe labour thrown away, if we state our own experience and\nrecord our own observations for the guidance of others, in\norder to show, with the utmost possible clearness, what\nfuture explorers have before them, and how best to meet it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("2. Undivided command in an expedition is the first of all\nrules; but if there be any division of command in a subordinate\nexpedition by sea or land, the duties and rights of its\ncommander must be clearly and exactly defined. In recent\ntimes the command of a Polar expedition has sometimes\nbeen conferred not on a seaman, but on a man of science, as\nin the cases of Kane, Hayes, Nordenskjöld, and Torell.\nWhere the investigation of questions connected with Natural\nHistory is the aim and object, this precedent is admissible,\nbut it should never be observed where the commander has\nan important part to fulfil as a navigator. The command of\nan expedition has never been conferred on a man of science\nby the English government. In the very commencement,\nindeed, of Polar discovery, an English expedition was placed\nunder the command of Sir Hugh Willoughby, who was not\nbred a sailor, but down to the seventeenth century, even in\ntheir naval campaigns, such men were appointed to naval\ncommands. The Dutch expeditions of the sixteenth century"), _c('span', {
    attrs: {
      "id": "pgepubid00065",
      "title": "[38]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_38",
      "title": "[38]"
    }
  })]), _vm._v("\ngenerally adopted a destructive division of command, under\nsupercargoes and pilots, representing the mercantile and\nnautical elements: confusion and discord were the inevitable\nconsequences.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("3. Next to the selection of a commander, the selection of\nthe crew demands the greatest care. This ought to be made\nsome time before the expedition starts, in order that those\nunfit for the service may be discovered, and their places\nsupplied by others; this cautious mode of procedure, and not\na preference for any particular nationality, will secure the\nmost effective crew. Although seamanlike qualities do not\nbelong in the same degree to every nation, time and pains\nonly are needed to secure a picked crew for a North-Pole\nexpedition from almost any nation. Endurance of cold is not\nthe only test of effectiveness, although this is a very common\nassumption; but a sense of duty, perseverance, and resolution\nare the virtues of a seaman. Habit soon teaches men to\nconquer cold, and inexorable necessity often hardens weaklings\ninto heroes for Arctic discovery. A certain degree of\nintelligence is of high importance in the crew. In many\ncases resolution in the midst of dangers depends on their\ncapacity to observe and think, even on their possessing certain\nbranches of knowledge. The greater part of the crew of the\n"), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Tegetthoff")]), _vm._v(" had these advantages. But men who, in a heavily-laded\nsledge, leave the old and take to recently-formed ice,\nwithout noticing the difference,—who observe a frost-bitten\nfoot several hours after the mischief has been done,—who lose\ntheir cartridges, know nothing of their rifle, and little more of\ntheir compass, or who pass on without observing the configurations\nof the land, possess an indifference indeed, but of a kind\nvery dangerous to themselves and to the whole party, though\nthey may despise death as much as Achilles is said to have\ndone.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("4. An intelligent crew, from their greater feeling of independence,\nis, however, more difficult to command than an\nignorant one. Devotion and blind confidence are more rarely\nfound in an educated crew; their amenability to discipline is\ndependent on the good example, the kindness and unalterable\ncalmness of those who may command them. The law of a\nPolar expedition is obedience, and its basis morality. Punishments"), _c('span', {
    attrs: {
      "id": "pgepubid00066",
      "title": "[39]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_39",
      "title": "[39]"
    }
  })]), _vm._v("\nare in such situations a miserable and depressing means\nfor the preservation of order, and then employment, especially\nin a private undertaking, will tend rather to loosen than to\nmaintain the bonds of discipline. If Parry, in 1820, caused\ncorporal punishments to be inflicted, this proves the greater\nfacility with which discipline is maintained on board of a\nman-of-war, but not its appropriateness generally. Coercion\nand threats produce no effect; and hence the folly of attempting\nto secure success by sending out again those who returned\nwithout having achieved anything, which was done last\ncentury by the authorities of St. Petersburg with every\nunsuccessful enterprise on the Arctic coasts of Siberia. The\nregulation that the most meritorious among the crew shall be\nspecially rewarded, after the return of the expedition, provides\nfor the recognition of merit, without exciting ill feeling in the\nless worthy. For the officers scientific success may be a\nperfect reward of their toils, but for the crew the reward\nshould consist of more material advantages. Money, indeed,\nseems a feeble motive of action to men destined to withstand\nfor years the inclemency of Arctic winters, and uncertain\nwhether they shall ever return; but, notwithstanding, it\nis the only form by which men without sympathy for the\naims of science can be gained for the attainment of such\nobjects. The crews of Sir John Ross received for a martyrdom\nof four years passed in the ice about £100 a head;\nin the second German expedition from eight to twelve\nthalers were the monthly pay of each sailor. The pay of\nthe sledgers in the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Tegetthoff")]), _vm._v(" was, however, nearly four times\nas much; in some sledge journeys it amounted to 3,000\ngulden a man.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("5. Contrary to what might be expected, the re-employment\nof those who have served before is not to be recommended as\na rule. The very best only should be re-enlisted. The others\nare too much disposed to place their experience on a level\nwith that of their commanders; and in all cases, where their\nopinions differ from those of their officers, they damage by a\nkind of passive opposition the fundamental law of an expedition—obedience.\nThose who enter the Arctic regions for the\nfirst time are wont to receive the orders of an experienced\ncommander with an attention as unquestioning as it is"), _c('span', {
    attrs: {
      "id": "pgepubid00067",
      "title": "[40]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_40",
      "title": "[40]"
    }
  })]), _vm._v("\nrespectful. Married men also should be excluded, as they\nwere by Barentz in his second (1596) expedition.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("6. Some of the crew should be good shots, good pedestrians\nand mountaineers, but all must be of the same\nnationality, and in perfect health. The least symptom of\nrheumatism, of diseases of the lungs and the eyes, and of\ncertain chronic maladies only too common among seamen,\nunfit them for the endurance of the Polar climate, and especially\nfor sledge expeditions. Those who are addicted to\ndrink are peculiarly liable to the scurvy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("7. The medical man of an expedition, besides professional\nskill and experience, must possess the most imperturbable\npatience, for to many of his patients he is not less a physician\nof the mind than of the body. He should convince himself\nof the sanitary condition of the crew before the expedition\nstarts, although it may have been previously investigated by\nmedical authorities and declared satisfactory.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("8. Since an expedition, in addition to its scientific functions,\nshould take up the illustration of Nature at the Pole, the\nemployment of a photographer, but still better of an artist, is\nvery desirable, for the former is too much confined to the\nimmediate neighbourhood of the ship in his operations.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("9. The records of Arctic adventure in former days tell us\nof equipments strangely incompatible with the object pursued.\nTheir commercial purpose constrained them to fill the hold\nwith bales of silk, instead of provisions for years; but the\nletters of recommendation which were given to the explorers\nof the North-East passage for the Saracen princes on the\nroute to Chatai seem peculiarly ludicrous. Some justification\nmay be discovered for Owczyn taking a priest with him\non his Siberian expedition (1734), but hardly for his wanting\nfifty-seven men in a vessel only seventy feet long, and arming\nit with eight falconets. The employment of a drummer,\ntwelve privates and a corporal, on Gmelin’s scientific Siberian\nexpedition, is still more unintelligible; more so than Davis’s\nband of music, which was intended to charm the feelings of\nthe Eskimos and dispose them to peaceful proceedings, his predecessor\nFrobisher having had the saddest experience of their\nbarbarism. Other expeditions by the too plentiful distribution\nof knives and hatchets among the Eskimos placed them in a"), _c('span', {
    attrs: {
      "id": "pgepubid00068",
      "title": "[41]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_41",
      "title": "[41]"
    }
  })]), _vm._v("\nposition seriously to threaten the white man, and even at the\npresent day the so-called “Wilden-kiste” often contains\narticles little calculated to inspire the natives with a high\nopinion of our moral superiority.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("10. In fitting out a Polar expedition, all respect should be\npaid to the principle of bestowing on those who are for a time\nbanished, the greatest possible amount of comfort. The proportions\nof a ship, and the space at its disposal, narrow the\nlimits available for this end; and since the return to the\nemployment, as at the first, of small vessels, even these limits\nhave been considerably diminished.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("11. The following table shows that the employment of\nsmall vessels was the principle at first followed, although the\nEnglish undertakings even of this present century never\nthoroughly adopted the example of a Fotherby, a Baffin, and\na Ross:—")]), _vm._v(" "), _c('table', {
    staticClass: "borders",
    attrs: {
      "summary": "Prior expeditions to the region"
    }
  }, [_c('tbody', {
    staticClass: "calibre11"
  }, [_c('tr', {
    staticClass: "calibre12"
  }, [_c('th', {
    staticClass: "calibre15",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Expeditions of")])]), _vm._v(" "), _c('th', {
    staticClass: "calibre15",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Tonnage of the Ships.")])]), _vm._v(" "), _c('th', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Provisioned for")])]), _vm._v(" "), _c('th', {
    staticClass: "calibre15"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Crew.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("A.D.")]), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Willoughby")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1553")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("120")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("90")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("160")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_vm._v("18 months")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Frobisher")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1576")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("25")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("25")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "center1"
  }, [_vm._v("”")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1577")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("180")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("30")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("30")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl",
    attrs: {
      "rowspan": "14"
    }
  }, [_vm._v("Mostly for one year only.")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Pett Jackman")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1580")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("40")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Davis")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1585")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("50")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("35")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("42")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "center1"
  }, [_vm._v("”")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("2nd expedn.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("50")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("53")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("120")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Weymouth")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1604")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("70")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("60")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Knight")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1606")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("40")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Hudson")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1607")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("10")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "center1"
  }, [_vm._v("”")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1608")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("James Poole")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1609")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("70")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Hudson")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1610")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("55")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Smith")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1610")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("50")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("James Poole")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1611")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("50")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Fotherby")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1615")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Baffin")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1616")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("58")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Fox")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1631")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_vm._v("18 months")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("20")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("James")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1631")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("70")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_vm._v("18 "), _c('span', {
    staticClass: "ditto"
  }, [_vm._v("”")])]), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Wood")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1676")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_vm._v("16 "), _c('span', {
    staticClass: "ditto"
  }, [_vm._v("”")])]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("19")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Moor")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1746")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("180")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("140")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Ross")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1818")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("385")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("252")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Parry")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1819")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("375")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("180")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_vm._v("2½ years")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Lütke")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1821")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("200")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("45")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Hayes")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1860")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("133")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_vm._v("1½ "), _c('span', {
    staticClass: "ditto"
  }, [_vm._v("”")])]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Koldewey")]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("1869")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("180")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("200")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "bl"
  }, [_c('span', {
    staticClass: "fraction"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "ditto"
  }, [_vm._v("”")])]), _vm._v(" "), _c('td', {
    staticClass: "center"
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("12. The inspection of this table shows that it was the\npractice of the sixteenth century to send out fleets of ships"), _c('span', {
    attrs: {
      "id": "pgepubid00069",
      "title": "[42]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_42",
      "title": "[42]"
    }
  })]), _vm._v("\nof a very small size, that in the seventeenth one small ship\nwas commissioned, and that the employment of two vessels\nhas been the rule since; and this would have been still more\nevident, if the various Franklin expeditions had been included\nin the above table. In 1829 Sir John Ross started\nwith a ship drawing eighteen feet, but changed afterwards to\none drawing eight feet; and from eight to twelve feet is now\nthe recognised draught in Polar ships. Large vessels require\na numerous crew, and if they have not been built exclusively\nfor the purpose of Polar exploration, their small economy of\nspace prevents their being fitted out for more than two years\nand a half. In 1819 Parry’s ship, the large "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Fury")]), _vm._v(", had, with a\ndraught of eighteen feet, provisions for only two and a half\nyears, whereas the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Victory")]), _vm._v(" (1829) of Ross with only seven feet\ndraught had on board, besides stores for the same period, a\nsteam-engine and coals for a thousand hours’ steaming. The\nRussian Novaya Zemlya navigators of this century have\nadopted vessels of a size which must be destructive of all\ncomfort and convenience. These vessels are thirty or forty\nfeet long, with a draught of five or six feet, and a crew of\nnine or ten men. But Arctic ships must have a crew above\nthe ordinary strength and be provided with steam-power; so\nthat, allowing for the necessary space for the quarters of the\ncrew, for the engines and the coalbunkers, little room will be\nleft for the stowage of stores. But this little should be reserved\nfor well-chosen provisions stowed away so as to avoid\nall empty spaces, and secure the greatest amount of resistance\nto lateral pressure. The weakest parts of a ship are always\nthe spaces left for air in the quarters of the men. A crew,\nwhich is exposed to threatening dangers from the ice, will\nnever regret the strengthening of these void spaces by heavy\nhorizontal tie-beams, removable when the ship is in the winter\nharbour, and so adjusted as not to impede communication.\nThe mere suspension of heavy beams against the hull of a\nship does not always answer the purpose of protection, since\nthe pressure of the ice frequently drives away these protecting\ntimbers. The practice, however, is not absolutely to be\nrejected.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("13. The daily allowance of solid food for the effectives in\nan Arctic expedition amounts to about two pounds, and in"), _c('span', {
    attrs: {
      "id": "pgepubid00070",
      "title": "[43]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_43",
      "title": "[43]"
    }
  })]), _vm._v("\nsledge expeditions to 2¾ pounds, of which half a pound is\nbread and one pound preserved meat. Besides the usual\nprovisions, large supplies of preserved vegetables, of cocoa, of\nextract of meat, of rice, of preserved peas, of dried farinaceous\nfood (such as macaroni), are very desirable. Salted\nmeat is to be avoided as much as possible. The luxury of\nfresh bread twice a week instead of the hard ship’s biscuit is\nan essential means of promoting health, and the want of\nyeast for its preparation may be supplied by “baking powder.”\nOnce a day a ration of lemon-juice should be served out as a\npreservative against scurvy, and anti-scorbutic victuals should\nbe laid in abundantly. Plenty of tea and tobacco is indispensable;\nthe want of these is painfully felt, especially by\nthe sailors. Cases have actually occurred, where crews have\nground the wooden blocks of the rigging to powder, to serve\nas tea, and have used the hoops of casks for tobacco.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("14. The moderate enjoyment of spirituous liquors is much\nto be recommended, as their influence on health and sociality\nis of great importance. The preservation, however, of a\nsufficient stock of wine, especially in winter, is a matter of\nmuch difficulty, since most kinds freeze at 21° F. or 14° F. As\nlong as the ship is afloat, as it generally is when winters are\npassed in the ice, it is advisable to preserve the supply of\nwine at the bottom of the hold, and to place all other things\nmost liable to be frozen in layers above it. But if a ship be\nnearly or entirely out of water, it is advisable to keep the\nwine, and other indispensable liquids, in the empty spaces of\nthe cabin, under the cabin table, near the stove, below the\nberths, and under the sky-light after it has been closed for the\nwinter. Only absolute want of space justifies the preparation\nof "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("chemical wine")]), _vm._v(","), _c('a', {
    staticClass: "reference",
    attrs: {
      "id": "FNanchor_13"
    }
  }), _c('span', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0043#Footnote_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[13]")]), _vm._v(" since the volume of its constituent parts\nwithout water is only a fifth of real wine; and under all\ncircumstances "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("chemical wine")]), _vm._v(" is but a miserable shift, and the\nbeer (even the spruce beer of Sir John Ross) which the English\nused to manufacture on board ship from the essence of malt\nand hops is far preferable. The rum and cognac, especially\nfor sledge expeditions, in order to save weight should contain\nthe greatest possible amount of alcohol, for its dilution before\nuse is a matter of no difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00071",
      "title": "[44]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_44",
      "title": "[44]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("15. During the winter, residence in the ship itself is preferable\nto living in log-houses, because the ship can be more\neasily heated and suffers less from the accumulation of ice.\nBut since a ship in the Arctic Sea ceases for ten months of the\nyear to be a ship and becomes in fact a house, this should be\nkept in view when she is being fitted out.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("16. The place where the men live is always in the fore-part\nof the ship, but their berths should be changed in a certain\nrotation, because of the inequality of the condensation. It is\nnot advisable to place the kitchen in the quarters of the crew\nin order to diminish the consumption of coals, because an\naccumulation of moisture is thereby increased. The officers\nand "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("savans")]), _vm._v(" occupy a common messroom in the after-part of\nthe ship, and sleep in little cabins ranged round it. The power\nto withdraw occasionally from the presence of those who must\nbe together for years is an important element of harmony.\nSir John Ross and his officers in 1833, even in the miserable\nhut built on the Fury coast, did not occupy the common\nmessroom heated by a stove, but preferred separate cabins,\nthe temperature of which seldom rose above the freezing point,\nand in which they had to suffer much from the accumulation\nof ice. All the living rooms should be provided with waterproof\ncarpets. Their heating by means of the common stoves\nis objectionable, because of the unequal distribution of warmth.\nAn even temperature is best maintained by the use of the\nMeidinger “Fullofen,” which has the further advantage of\nconsuming only a small quantity of coals. Hot-air flues are,\nperhaps, preferable even to these, because they better prevent\nthe freezing of the moisture in the cabins, and indeed in every\npart of the ship.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("17. An Arctic ship should be provided with an iron-plated\nwashing and drying closet, without which the washing of\nlinen would be restricted to the few weeks of summer weather.\nThis closet may also be used as a bath-room, an important\nmeans of promoting health. The lighting of the living\nrooms by petroleum sufficiently answers all purposes; in the\ncabins, however, stearine candles are to be preferred either to\nit or any other oil. The construction of the lamps used in\nmaking observations in the open air during the long Arctic\ndarkness is a matter of the greatest importance. Those used"), _c('span', {
    attrs: {
      "id": "pgepubid00072",
      "title": "[45]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_45",
      "title": "[45]"
    }
  })]), _vm._v("\nin the second German North-Pole Expedition were of peculiar\nexcellence, and never failed in their difficult service. Massive\nlamps, with glass globes protected with wire, and burning\npetroleum in preference to common oil, should be used on\ndeck, and as they are employed for so many purposes and\nexposed to so many risks, a plentiful supply of them should\nbe provided. In the huts on the deck, built over the hatchways,\ntrain-oil may be used with advantage, if the lamps are\nso constructed that the flame may heat the reservoir containing\nthe oil.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("18. So long as the crew remains on board the ship, their\nclothing, even in the severest winter, needs but little attention.\nThick close-fitting woollen under-garments, knitted woollen\ngloves, outer-garments of strong cloth, are in all cases sufficient\non deck, and in all those parts of the ship which are\nkept at a certain temperature. Leather boots lined with\nfur were long considered an indispensable requisite for Polar\nexpeditions, but they have not maintained their character,\nas they are very heavy, become unpliable in frost, and\nsoon quite useless through its action and the wearing off\nof the fur.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("19. Before the departure of the expedition, all the instruments\nshould be thoroughly cleansed from oil by a practical\noptician, and the fire-arms should undergo a like operation at\nthe hands of the gunmaker, and their barrels should be\nbrowned to protect them better from rust. The ammunition,\npowder and matches to blast the ice, alcohol and petroleum,\nshould be stowed in the after-part of the ship, and the two\nlatter should be reached only through a closely-fitting pump.\nA very ample supply of alcohol, flannel, buffalo-skins, strong\ncloth, water-proof canvas, felt, leather, reindeer shoes, snow\nboots, shovels, cramp irons, poles, &c., articles which are too\noften overlooked, should be taken, both from their usefulness\non board ship and also on land expeditions.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("20. The costs of Polar expeditions have relatively rather\ndiminished than increased. The expenses of Willoughby’s\nexpedition 300 years ago amounted to the sum—quite enormous\nfor that day—of £6,000; Moor’s (1746) cost £10,000;\nwhile Back’s difficult but successful undertaking to explore\nthe great Fish-river (1833-1835), only £5,000. The Siberian"), _c('span', {
    attrs: {
      "id": "pgepubid00073",
      "title": "[46]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_46",
      "title": "[46]"
    }
  })]), _vm._v("\nexpedition of Middendorf (1844)—costing only 13,300 rubles\n(£1,717)—was a matchless example of extraordinary achievements\nwith little expenditure. The costs of the various\nFranklin Expeditions from 1848 to 1854 amounted, according\nto the statement of the English Admiralty, to twenty million\nfrancs (£833,333); those of the second German North-Pole\nExpedition to 120,000 thalers (£11,000), and the expenses of\nour own Austrian-Hungarian North Pole Expedition to 220,000\ngulden (£18,333).")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00074",
      "title": "[47]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_47",
      "title": "[47]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2ce28d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0012.vue
// module id = 90
// module chunks = 0